exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "button._38fykB5b{border:0;color:inherit;cursor:pointer;font-family:'Helvetica Neue',Helvetica,Arial,sans-serif;font-size:14px;font-weight:400;padding:0;text-decoration:underline}@media (hover:hover){button._38fykB5b:hover:not(:active){color:#ec0000}}", ""]);

// Exports
exports.locals = {
	"screenLink": "_38fykB5b"
};